module.exports = __webpack_public_path__ + "static/media/schlauch_fragezeichen.a6f576ae.jpg";